/* MOEGIS storefront helpers
   商品詳細ページのタイトルを1行に収める（長い場合はフォントを自動縮小）。
   最小サイズでも収まらない長い商品名は、切れて読めなくならないよう通常の折り返しに戻す。 */
(function () {
  function fitTitle(el) {
    if (!el) return;
    el.style.whiteSpace = 'nowrap';
    el.style.overflow = 'hidden';
    el.style.overflowWrap = '';
    el.style.fontSize = ''; // CSS既定にリセット
    // 非表示要素（clientWidth=0）はスキップ
    if (el.clientWidth === 0) return;
    var size = parseFloat(window.getComputedStyle(el).fontSize);
    var min = 12, guard = 0;
    while (el.scrollWidth > el.clientWidth && size > min && guard < 300) {
      size -= 0.5;
      el.style.fontSize = size + 'px';
      guard++;
    }
    if (el.scrollWidth > el.clientWidth) {
      // 最小サイズでもはみ出す → 縮小をやめて折り返し表示にする
      el.style.fontSize = '';
      el.style.whiteSpace = 'normal';
      el.style.overflow = '';
      el.style.overflowWrap = 'anywhere';
    }
  }

  function run() {
    var sel = '.product__info-container .product__title > h1, .product__info-container .product__title .h1';
    document.querySelectorAll(sel).forEach(fitTitle);
  }

  if (document.readyState !== 'loading') {
    run();
  } else {
    document.addEventListener('DOMContentLoaded', run);
  }
  // 画像/フォント読込後に再調整
  window.addEventListener('load', run);

  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(run, 150);
  });
})();

/* 商品ページ：同じ追加操作の二重送信を防ぐ
   ・追加POSTの完了までは対象ボタンを無効化する
   ・すでにカートにある商品は「カートに追加済み」と表示する
   ・ライセンス数は商品ページまたはカートの数量入力で変更できる */
(function () {
  var inCart = {}; // variantId(文字列) -> true
  var pendingAdd = {}; // 追加処理中でまだサーバー確定していない variantId
  var drawerOpenedByAdd = false; // 追加クリックでドロワーを先に開いたか（失敗時に閉じるため）
  // 商品詳細ページのカートボタン・一覧のクイック追加・一覧のミニ追加ボタンを対象にする
  var SEL =
    '.product-form__submit[data-moe-variant-id], .quick-add__submit[data-moe-variant-id], .moe-addmini[data-moe-variant-id]';

  function applyButtons() {
    document.querySelectorAll(SEL).forEach(function (btn) {
      var vid = btn.getAttribute('data-moe-variant-id');
      // アイコンだけのミニボタン（一覧）はテキストを書き換えず、見た目はCSSでアイコンを切替
      var isIcon = btn.classList.contains('moe-addmini');
      var span = isIcon ? null : btn.querySelector('span');
      var addedLabel = btn.getAttribute('data-moe-added-label') || 'カートに追加済み';
      var addLabel = btn.getAttribute('data-moe-add-label') || 'カートに追加';
      if (inCart[vid]) {
        btn.setAttribute('disabled', 'disabled');
        btn.classList.add('moe-in-cart');
        btn.setAttribute('aria-label', addedLabel);
        if (span) span.textContent = addedLabel;
      } else if (btn.classList.contains('moe-in-cart')) {
        // 「追加済み」で無効化していたものだけ元に戻す（売切れ等の無効化には触れない）
        btn.classList.remove('moe-in-cart');
        btn.removeAttribute('disabled');
        btn.setAttribute('aria-label', addLabel);
        if (span) span.textContent = addLabel;
      }
    });
  }

  function hasPendingAdds() {
    return Object.keys(pendingAdd).length > 0;
  }

  function setFromCart(cart) {
    inCart = {};
    ((cart && cart.items) || []).forEach(function (it) {
      inCart[String(it.variant_id)] = true;
    });
    // 別商品の追加POSTがまだ進行中なら、古いカート取得結果でボタンを戻さない。
    Object.keys(pendingAdd).forEach(function (vid) {
      inCart[vid] = true;
    });
    applyButtons();
    if (!hasPendingAdds()) hideCartSpinner();
  }

  function refresh() {
    var base = (window.routes && window.routes.cart_url) ? window.routes.cart_url : '/cart';
    return fetch(base + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(setFromCart)
      .catch(function () {
        applyButtons();
        if (!hasPendingAdds()) hideCartSpinner();
      });
  }

  function settleAdd(event, failed) {
    var vid = event && event.productVariantId ? String(event.productVariantId) : '';
    if (vid) {
      delete pendingAdd[vid];
      if (failed) delete inCart[vid];
    }
    return refresh();
  }

  // ドロワーを即開いた直後〜カート内容が更新されるまで出す軽いスピナー。
  // ドロワーの内部に置くと transform のスタッキング文脈に埋もれて見えないため、
  // body 直下の固定オーバーレイ（z-index でドロワーより前面）にして確実に見せる。
  var spinnerTimer = null;
  var spinnerShownAt = 0;
  function showCartSpinner() {
    if (!document.getElementById('moe-cart-spinner')) {
      var sp = document.createElement('div');
      sp.id = 'moe-cart-spinner';
      sp.className = 'moe-cart-spinner';
      sp.setAttribute('aria-hidden', 'true');
      document.body.appendChild(sp);
    }
    // 連続追加でも最低表示時間の起点を更新する（2回目のクリックで即消えないように）
    spinnerShownAt = Date.now();
    // 追加POSTが完了するまで表示し、cartUpdate/cartErrorで閉じる。
    clearTimeout(spinnerTimer);
  }
  function hideCartSpinner() {
    // 追加が速いと一瞬で消えて見えないため、最低表示時間を確保する
    var minMs = 450;
    var elapsed = spinnerShownAt ? Date.now() - spinnerShownAt : minMs;
    if (elapsed < minMs) {
      clearTimeout(spinnerTimer);
      spinnerTimer = setTimeout(hideCartSpinner, minMs - elapsed);
      return;
    }
    clearTimeout(spinnerTimer);
    spinnerShownAt = 0;
    var sp = document.getElementById('moe-cart-spinner');
    if (sp && sp.parentNode) sp.parentNode.removeChild(sp);
  }

  // クリックを捕捉して二重追加をブロック（disabled が間に合わない環境でも確実に止める）
  document.addEventListener(
    'click',
    function (e) {
      var btn =
        e.target && e.target.closest ? e.target.closest(SEL) : null;
      if (!btn) return;
      var vid = btn.getAttribute('data-moe-variant-id');
      if (inCart[vid]) {
        // すでにカートにある → 追加させない
        e.preventDefault();
        e.stopImmediatePropagation();
        return;
      }
      // 1回目は許可。以降のクリックは即ブロックできるよう先にフラグを立てる
      inCart[vid] = true;
      pendingAdd[vid] = true;
      // クリックした瞬間にカートドロワーを開く（追加の通信待ちでも即反応させ、
      // 「無反応のあと急に出てくる」唐突さをなくす。中身は追加完了後に更新される）
      var moeDrawer = document.querySelector('cart-drawer');
      if (
        moeDrawer &&
        typeof moeDrawer.open === 'function' &&
        !moeDrawer.classList.contains('active')
      ) {
        try {
          moeDrawer.open(btn);
          drawerOpenedByAdd = true;
        } catch (err) {
          /* 失敗しても追加処理は継続 */
        }
      }
      // 追加処理中であることを示す軽いスピナーを表示（更新完了で自動的に消える）
      showCartSpinner();
      // 送信が始まった後に見た目も「追加済み」へ
      setTimeout(applyButtons, 250);
    },
    true
  );

  // ヘッダーのカートアイコンはドロワーを開かずカートページ(/cart)へ遷移させる。
  // cart-drawer.js が #cart-icon-bubble のクリックを preventDefault してドロワーを開くため、
  // キャプチャ段階で伝播を止めて、<a href="{{ routes.cart_url }}"> の通常遷移を生かす。
  // （点数バッジの更新・カート削除の修正に必要な #cart-icon-bubble はそのまま残す）
  document.addEventListener(
    'click',
    function (e) {
      var icon = e.target && e.target.closest ? e.target.closest('#cart-icon-bubble') : null;
      if (!icon) return;
      e.stopImmediatePropagation();
    },
    true
  );

  // キーボード操作もカートページ遷移に統一する。
  // cart-drawer.js は #cart-icon-bubble の keydown(Space) でドロワーを開くため、
  // Space はドロワーを止めて /cart へ遷移、Enter はドロワーだけ止めてリンク既定遷移を生かす。
  document.addEventListener(
    'keydown',
    function (e) {
      var icon = e.target && e.target.closest ? e.target.closest('#cart-icon-bubble') : null;
      if (!icon) return;
      if (e.key === ' ' || e.key === 'Spacebar' || e.keyCode === 32) {
        e.preventDefault();
        e.stopImmediatePropagation();
        var href = icon.getAttribute('href');
        if (href) window.location.href = href;
      } else if (e.key === 'Enter') {
        e.stopImmediatePropagation();
      }
    },
    true
  );

  // cart-drawer.js が付ける role="button" / aria-haspopup="dialog" を打ち消し、
  // 実挙動（/cart へのリンク）に合わせてスクリーンリーダーへ正しく伝える。
  (function () {
    var icon = document.getElementById('cart-icon-bubble');
    if (!icon) return;
    var strip = function () {
      icon.removeAttribute('role');
      icon.removeAttribute('aria-haspopup');
      icon.removeAttribute('aria-expanded');
    };
    strip();
    setTimeout(strip, 0);
    // cart-drawer.js（defer）が後から属性を付けるため、定義完了後にもう一度外す
    if (window.customElements && customElements.whenDefined) {
      customElements.whenDefined('cart-drawer').then(function () {
        strip();
        setTimeout(strip, 0);
      });
    }
  })();

  if (document.querySelector(SEL)) {
    // 現在のカート状態で初期化（リロードなしの判定にも使う）
    refresh();
    // 「戻る」で bfcache から復元されたページは古い「追加済み」状態のままなので取り直す
    window.addEventListener('pageshow', function (e) {
      if (e.persisted) refresh();
    });
    // 追加/削除・エラーイベントに追従
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS) {
      if (PUB_SUB_EVENTS.cartUpdate) {
        subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) { return settleAdd(event, false); });
      }
      // POSTが失敗してからロックを解除するため、低速通信中の再送は発生しない。
      if (PUB_SUB_EVENTS.cartError) {
        subscribe(PUB_SUB_EVENTS.cartError, function (event) {
          // 追加に失敗したのにドロワーが開いたままだと、商品フォームのエラー文が背面に隠れて
          // 「何も起きない」ように見える。先に開いたドロワーは閉じてエラーを見せる。
          if (drawerOpenedByAdd) {
            var d = document.querySelector('cart-drawer');
            if (d && typeof d.close === 'function' && d.classList.contains('active')) {
              try { d.close(); } catch (err) { /* noop */ }
            }
          }
          drawerOpenedByAdd = false;
          return settleAdd(event, true);
        });
      }
      // 商品ページでバリエーションを切り替えたら、二重追加防止の対象IDも追従させる。
      // Dawn は新バリエーションのボタン状態を取得HTMLの disabled で決めるため、
      // 「カートに追加済み」で無効化された HTML を受け取ると「売り切れ」表示になってしまう。ここで正しい状態に戻す。
      if (PUB_SUB_EVENTS.variantChange) {
        subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
          var data = event && event.data;
          if (!data || !data.sectionId) return;
          var btn = document.getElementById('ProductSubmitButton-' + data.sectionId);
          if (!btn) return;
          var variant = data.variant;
          if (!variant) return; // 存在しない組み合わせ → Dawn の「利用不可」表示に任せる
          btn.setAttribute('data-moe-variant-id', String(variant.id));
          var span = btn.querySelector('span');
          var addLabel = btn.getAttribute('data-moe-add-label') || 'カートに追加';
          if (inCart[String(variant.id)]) {
            applyButtons();
          } else if (variant.available) {
            btn.classList.remove('moe-in-cart');
            btn.removeAttribute('disabled');
            btn.setAttribute('aria-label', addLabel);
            if (span) span.textContent = addLabel;
          } else {
            // 本当に売り切れのバリエーション（Dawn の表示のまま）
            btn.classList.remove('moe-in-cart');
          }
        });
      }
    }
  }
})();

/* モバイルメニュー（≤900px）の開閉。
   PCナビ/検索がこの幅で隠れるため、これが唯一の主要導線になる。 */
(function () {
  var burger = document.querySelector('[data-moe-burger]');
  var panel = document.getElementById('moe-mnav');
  if (!burger || !panel) return;
  var overlay = document.querySelector('[data-moe-mnav-overlay]');
  var closers = document.querySelectorAll('[data-moe-mnav-close]');

  function isOpen() {
    return burger.getAttribute('aria-expanded') === 'true';
  }
  function open() {
    panel.hidden = false;
    if (overlay) overlay.hidden = false;
    burger.setAttribute('aria-expanded', 'true');
    document.documentElement.style.overflow = 'hidden';
    var first = panel.querySelector('a, input, button');
    if (typeof trapFocus === 'function' && first) {
      trapFocus(panel, first);
    } else if (first) {
      try { first.focus({ preventScroll: true }); } catch (err) { first.focus(); }
    }
  }
  function close(refocus) {
    if (typeof removeTrapFocus === 'function') {
      removeTrapFocus(refocus ? burger : null);
    }
    panel.hidden = true;
    if (overlay) overlay.hidden = true;
    burger.setAttribute('aria-expanded', 'false');
    document.documentElement.style.overflow = '';
    if (refocus && typeof removeTrapFocus !== 'function') burger.focus();
  }

  burger.addEventListener('click', function () {
    if (isOpen()) close(true); else open();
  });
  if (overlay) overlay.addEventListener('click', function () { close(false); });
  Array.prototype.forEach.call(closers, function (el) {
    el.addEventListener('click', function () { close(true); });
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && isOpen()) close(true);
  });
  window.addEventListener('resize', function () {
    if (window.innerWidth > 900 && isOpen()) close(false);
  });
})();

/* 言語切替ドロップダウン（ヘッダーPC・モバイルメニュー共通）
   snippets/moegis-lang-picker.liquid の [data-moe-lang] フォームを制御する。
   選択肢クリック → hidden の locale_code を書き換えてフォーム送信（Shopifyが同ページの言語版へ戻す）。 */
(function () {
  var pickers = document.querySelectorAll('form[data-moe-lang]');
  if (!pickers.length) return;

  function closeAll() {
    pickers.forEach(function (root) {
      root.classList.remove('is-open');
      var t = root.querySelector('[data-moe-lang-toggle]');
      if (t) t.setAttribute('aria-expanded', 'false');
    });
  }

  pickers.forEach(function (root) {
    var toggle = root.querySelector('[data-moe-lang-toggle]');
    var input = root.querySelector('[data-moe-lang-input]');
    if (!toggle) return;

    toggle.addEventListener('click', function (e) {
      e.stopPropagation();
      var willOpen = !root.classList.contains('is-open');
      closeAll();
      if (willOpen) {
        root.classList.add('is-open');
        toggle.setAttribute('aria-expanded', 'true');
      }
    });

    root.querySelectorAll('.moe-lang-opt[data-value]').forEach(function (opt) {
      opt.addEventListener('click', function () {
        if (input) input.value = opt.getAttribute('data-value');
        if (root.requestSubmit) { root.requestSubmit(); } else { root.submit(); }
      });
    });
  });

  document.addEventListener('click', function (e) {
    var inside = false;
    pickers.forEach(function (root) {
      if (root.contains(e.target)) inside = true;
    });
    if (!inside) closeAll();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeAll();
  });
})();

/* ロゴマーク：ホバーで葉が舞うアニメーションを1回だけ再生する。
   CSSの :hover だけだと、マウスが離れた時点でコマ送りが途中終了して静止マークに戻ってしまう。
   mouseenter でクラスを付け animationend で外すことで、離れても最後まで再生しきる。
   再生中の再ホバーでは二重に始めない（1ホバー＝1再生）。 */
(function () {
  var mark = document.querySelector('.moe-logo .moe-mk');
  if (!mark) return;
  var logo = mark.parentNode;
  if (!logo) return;

  logo.addEventListener('mouseenter', function () {
    if (!mark.classList.contains('is-playing')) {
      mark.classList.add('is-playing');
    }
  });
  mark.addEventListener('animationend', function () {
    mark.classList.remove('is-playing');
  });
})();

/* 並び替え・言語切替のドロップダウンをキーボードで操作できるようにする。
   ・キーボードで開いたら現在の選択肢（なければ先頭）へフォーカス
   ・↑↓/Home/End で選択肢を移動、Esc で閉じてトグルへフォーカスを戻す
   ・フォーカスがメニューの外へ出たら閉じる */
(function () {
  var ROOT = 'form[data-moe-lang], [data-moe-sort]';
  var TOGGLE = '[data-moe-lang-toggle], [data-moe-sort-toggle]';
  var OPT = '.moe-lang-opt, .moe-sort-opt';

  function opts(root) {
    return Array.prototype.slice.call(root.querySelectorAll(OPT));
  }
  function closeRoot(root, refocus) {
    root.classList.remove('is-open');
    var t = root.querySelector(TOGGLE);
    if (t) {
      t.setAttribute('aria-expanded', 'false');
      if (refocus) t.focus();
    }
  }
  function focusOpt(root, which) {
    var list = opts(root);
    if (!list.length) return;
    var cur = list.indexOf(document.activeElement);
    var i;
    if (which === 'first') i = 0;
    else if (which === 'last') i = list.length - 1;
    else if (which === 'active') {
      i = list.findIndex(function (o) { return o.getAttribute('aria-current') === 'true'; });
      if (i < 0) i = 0;
    } else i = (cur + which + list.length) % list.length;
    list[i].focus();
  }

  // キーボード（Enter/Space）でトグルを押したとき：既存ハンドラで開いた後にフォーカスを移す
  document.addEventListener('click', function (e) {
    var t = e.target && e.target.closest ? e.target.closest(TOGGLE) : null;
    if (!t || e.detail !== 0) return;
    var root = t.closest(ROOT);
    setTimeout(function () {
      if (root && root.classList.contains('is-open')) focusOpt(root, 'active');
    }, 0);
  }, true);

  document.addEventListener('keydown', function (e) {
    var root = e.target && e.target.closest ? e.target.closest(ROOT) : null;
    if (!root) return;
    var onToggle = !!e.target.closest(TOGGLE);
    var onOpt = !!e.target.closest(OPT);
    if (e.key === 'Escape' && root.classList.contains('is-open')) {
      closeRoot(root, true);
      return;
    }
    if (onToggle && e.key === 'ArrowDown') {
      e.preventDefault();
      if (!root.classList.contains('is-open')) e.target.closest(TOGGLE).click();
      setTimeout(function () { focusOpt(root, 'active'); }, 0);
      return;
    }
    if (!onOpt) return;
    if (e.key === 'ArrowDown') { e.preventDefault(); focusOpt(root, 1); }
    else if (e.key === 'ArrowUp') { e.preventDefault(); focusOpt(root, -1); }
    else if (e.key === 'Home') { e.preventDefault(); focusOpt(root, 'first'); }
    else if (e.key === 'End') { e.preventDefault(); focusOpt(root, 'last'); }
  }, true); // キャプチャ：既存の Esc 一括クローズより先に処理してフォーカスを戻す

  document.addEventListener('focusin', function (e) {
    document.querySelectorAll(ROOT).forEach(function (root) {
      if (root.classList.contains('is-open') && !root.contains(e.target)) closeRoot(root, false);
    });
  });
})();

/* 試聴プレーヤー：1つ再生したら他の再生中の音声を止める（音が重ならないように） */
document.addEventListener('play', function (e) {
  var cur = e.target;
  if (!cur || cur.tagName !== 'AUDIO') return;
  document.querySelectorAll('audio').forEach(function (a) {
    if (a !== cur && !a.paused) a.pause();
  });
}, true);
